import React from 'react';

export const LoadingComponent: React.FC = () => {
  return <p>Authentication in progress...</p>;
};
